import { selectChartScope } from "../utils/scopedChartDataUtils";

export const selectSensorDataState = (state, scope) =>
  selectChartScope(state.sensorData, scope);
